import _ from 'lodash';
import config from '../config';

export function useMock(name) {
  return _.get(config, `mock.${name}`, false);
}

export function sleep(time) {
  return new Promise(resolve => setTimeout(resolve, time));
}

export function createUid() {
  return Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);
}



// WEBPACK FOOTER //
// ./src/utils/helpers.js